(function(window, document, $, undefined){
  


  // -----------------------------------------------------------------------------------------------------
  // sticky elements - adds class 'fixed' to whatever when hitting top of page plus an optional offset
  // -----------------------------------------------------------------------------------------------------
  // function createSticky(sticky,options) {
  //   if(sticky.length<=0) return;
  //   positionSticky(sticky,options);
  //   $(window).on("scroll", function() {
  //       positionSticky(sticky,options);
  //   });
  // }
  // function positionSticky(sticky,options){
  //   var pos = sticky.offset().top;
  //   ($(window).scrollTop()+options.offset) > pos ? sticky.addClass("fixed") : sticky.removeClass("fixed");
  // }
  // var elementHeight = $('.site-header .top-bar').outerHeight();
  // createSticky($('.site-header .main-navigation'),{offset:elementHeight});
  // createSticky($('.site-header .top-bar'),{offset:0});




  // makes things sticky and stacky
  // MUST be in order top to bottom - because the stack height is accumulated so it knows where to stack the next one underneath.
  // you need to target the sticky things container - this is so the container is 'left' at its size in the DOM so there's no content position shifting
  // all this really does is add the classes and height at the right times in scroll anyway, CSS controls the sticking

  // on scroll method...
  function sticky(){
    // the things to make sticky (the thing inside it is actually fixed)
    stickyContainers = [
      // '.site-header .top-bar',
      // '.site-header .main-navigation',
    ];
    var stackedHeight = 0;
    // var prevContainerHeight = 0;
    $(stickyContainers).each(function(index, el) {
      var sticky = $(stickyContainers[index]);
      var containerHeight = sticky.outerHeight();
      var pos = sticky.offset().top;
      if(($(window).scrollTop()+stackedHeight) > pos){
        sticky.height(containerHeight);
        sticky.children(':first').css('margin-top',stackedHeight);
        sticky.addClass('fixed');
      } else {
        sticky.height('auto');
        sticky.children(':first').css('margin-top',0);
        sticky.removeClass('fixed');
      }
      stackedHeight += containerHeight;
      // prevContainerHeight = containerHeight;

    });


  }
  // setTimeout(function(){
  //   $(window).on("scroll", sticky);
  // },1000);

  $(window).load(function(){  
    $(window).on("scroll", sticky);
    sticky();
  });

  // //on resize method...
  // var stickyContainers = [
  //   '.site-header .top-bar',
  //   '.site-header .main-navigation',
  // ];
  // //set as objects with attributes
  // $(stickyContainers).each(function(index, el) {
  //   var sticky = stickyContainers[index];
  //   sticky = {selector:sticky,height:$(sticky).outerHeight(),pos:$(sticky).offset().top}
  //   stickyContainers[index] = sticky;
  // });
  // // recalculate sizes and offsets on resize, set them to the objects
  // function stickyResize(){
  //   $(stickyContainers).each(function(index, el) {
  //     var sticky = $(stickyContainers[index].selector);
  //     stickyContainers[index].height = sticky.outerHeight();
  //     stickyContainers[index].pos = sticky.offset().top;
  //   });
  //   stickyScroll();
  // }
  // // on scroll, check positions and set fixed
  // // WARNING!!! this sets the first child margin!!
  // // this all works by fixing the first child of the sticky div
  // // this is so the container can be left 'empty' in the dom to keep page proportions
  // // otherwise content would jump around
  // function stickyScroll(){
  //    var stackedHeight = 0;
  //   $(stickyContainers).each(function(index, el) {
  //     var sticky = $(stickyContainers[index].selector);
  //     var containerHeight = stickyContainers[index].height;
  //      if(($(window).scrollTop()+stackedHeight) > stickyContainers[index].pos){
  //         sticky.height(containerHeight);
  //         sticky.children(':first').css('margin-top',stackedHeight);
  //         sticky.addClass('fixed');
  //       } else {
  //         sticky.height('auto');
  //         sticky.children(':first').css('margin-top',0);
  //         sticky.removeClass('fixed');
  //       }
  //     stackedHeight += containerHeight;
  //   });
  // }

  // $(window).on("scroll", stickyScroll);
  // $(window).on("resize", stickyResize);



})(window, document, jQuery);
